import module from 'fan/proyecto/module.js'
import template from './template.html'
import {orderBy} from 'lodash'

export class FanProyectoDocumentosPlantillasComponent {
  idProyecto = undefined
  carpetas = {}

  constructor (FanProyectoDocumentosPlantillasService) {
    this.FanProyectoDocumentosPlantillasService = FanProyectoDocumentosPlantillasService
  }

  $onInit () {
    this.promise = this.FanProyectoDocumentosPlantillasService.get(this.idProyecto)
      .then(({data}) => {
        if (data.length) {
          this.data = this.procesarData(data)
        }
      })
  }

  procesarData (data) {
    let temporal = []
    data.forEach(item => {
      let rutas = item.ruta.split('/')
      let nombre = ''
      let ruta = ''

      rutas.reduce((acumulador, element, indice, array) => {
        let isDir = true
        nombre = array[indice]

        if (indice === array.length - 1) {
          nombre = item.nombre
          isDir = false
        }

        let obj = {
          tipo: isDir ? 1 : 2,
          nombre,
          ubicacion: ruta,
          id_plantilla: isDir ? null : item.id_plantilla,
          version: isDir ? null : item.version,
          contenido: isDir ? [] : null,
        }

        temporal[ruta + nombre + '/'] = temporal[ruta + nombre + '/'] ? temporal[ruta + nombre + '/'] : obj

        if (temporal[ruta]) {
          if (!temporal[ruta].contenido.find((item) => item.nombre === obj.nombre && item.ubicacion === obj.ubicacion))
            temporal[ruta].contenido.push(obj)
        }

        ruta = ruta + element + '/'
      }, 0)
    })

    temporal['/'].contenido = orderBy(temporal['/'].contenido, ['tipo', 'nombre'])

    return temporal['/'].contenido
  }
}

module.component('fanProyectoDocumentosPlantillas', {
  controller: FanProyectoDocumentosPlantillasComponent,
  template: template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/plantillas/component.js